export function calculateAge(dob: Date | string | null | undefined): number {
  if (!dob) return 0;
  const birth = dob instanceof Date ? dob : new Date(dob);
  return Math.floor((Date.now() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
}

export function formatDate(dateStr: string | null | undefined, locale?: string): string {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  let resolvedLocale = locale;
  if (!resolvedLocale) {
    try {
      const i18n = require('../i18n').default;
      resolvedLocale = i18n.language;
    } catch {
      resolvedLocale = 'en';
    }
  }
  return d.toLocaleDateString(resolvedLocale, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatTime(timeStr: string | null | undefined): string {
  if (!timeStr) return '-';
  const parts = timeStr.split(':');
  const hour = parseInt(parts[0], 10);
  const minute = parts[1];
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const h = hour % 12 || 12;
  return `${h}:${minute} ${ampm}`;
}

export function formatCurrency(amount: number | string, currency = 'VND'): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return new Intl.NumberFormat('vi-VN', { style: 'currency', currency }).format(num);
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function pluralize(count: number, singular: string, plural?: string): string {
  return count === 1 ? `${count} ${singular}` : `${count} ${plural || singular + 's'}`;
}

// Unit conversion helpers
const KG_PER_LB = 0.453592;
const CM_PER_IN = 2.54;

export function kgToLbs(kg: number): number { return kg / KG_PER_LB; }
export function lbsToKg(lbs: number): number { return lbs * KG_PER_LB; }
export function cmToIn(cm: number): number { return cm / CM_PER_IN; }
export function inToCm(inches: number): number { return inches * CM_PER_IN; }

export function weightToKg(value: number, unit: 'metric' | 'imperial'): number {
  return unit === 'imperial' ? lbsToKg(value) : value;
}
export function heightToCm(value: number, unit: 'metric' | 'imperial'): number {
  return unit === 'imperial' ? inToCm(value) : value;
}

export function displayWeight(kg: number, unit: 'metric' | 'imperial'): string {
  return unit === 'imperial' ? `${Math.round(kgToLbs(kg))} lbs` : `${Math.round(kg)} kg`;
}
export function displayHeight(cm: number, unit: 'metric' | 'imperial'): string {
  return unit === 'imperial' ? `${Math.round(cmToIn(cm))} in` : `${Math.round(cm)} cm`;
}

export function getApiError(
  error: unknown,
  fallback: string,
  t?: (key: string, opts?: any) => string,
): string {
  const detail = (error as any)?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((e: any) => e.msg).join('\n');
  }
  if (typeof detail === 'string') {
    // If detail looks like an i18n key and we have a translator, resolve it
    if (t && detail.startsWith('errors.')) {
      return t(detail, { defaultValue: detail });
    }
    return detail;
  }
  return fallback;
}
